import React from 'react'
import { HeadlessTableClientState } from './types'

export const HeadlessTableContext = React.createContext<HeadlessTableClientState<any>>(null as any)
